import { parseFromLocalStorage } from '@exchange-frontends/utils';

export const orgsStoreSlice = (_set, _get) => ({
  selectedOrg: parseFromLocalStorage('selectedOrg'),
  orgsFetchError: null,
});
